@import "@/scss/use-bootstrap-mixins";

.wrapper {
  // width: 100%;
  left: 24px;
  bottom: 24px;
  right: 24px;
  max-width: 740px;
  margin: 0 auto;
  touch-action: none;
  margin-top: 24px;

  &::-webkit-scrollbar {
    display: none;
  }

  @include media-breakpoint-up(lg) {
    margin-top: 12px;
    position: initial;
  }

  .track {
    width: 100%;
    background-color: #f0f0f0;
    height: 8px;
    position: relative;

    &::-webkit-scrollbar {
      display: none;
    }

    .track_container {
      position: relative;
      // overflow-y: hidden;
      overflow: hidden;
      height: 8px;

      &::-webkit-scrollbar {
        display: none;
      }

      .thumb_shadow {
        width: 8px;
        height: 8px;
        top: 0px;
        border-radius: 16px;
        position: absolute;
        box-shadow: 0px 0px 100px 30px var(--rs-theme);
        z-index: 3;
      }
    }

    .step_wrapper {
      z-index: 1;
      position: absolute;
      left: 0;
      right: 0;
      display: flex;
      justify-content: space-between;
      margin-top: -14px;

      .step {
        width: 2px;
        height: 22px;
        background-color: #f0f0f0;
      }
    }
  }

  .thumb {
    background-color: $textColorOnPrimary;
    height: 32px;
    width: 32px;
    border-radius: 16px;
    border: 11px solid var(--rs-theme);
    position: absolute;
    top: -12px;
    z-index: 10;

    &:hover {
      cursor: pointer;
      border: 9px solid var(--rs-theme);
    }
  }

  .labels {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    color: #000;
    opacity: 0.7;
    font-size: 12px;
    font-weight: 600;
  }
}
